import * as Yup from "yup";

import {
  Button,
  DialogActions,
  Tab,
  Tabs,
} from "@material-ui/core";
import { Form, Formik } from "formik";

import CreatePortAuthorityForm from "./CreatePortAuthorityForm";
import CreatePortAuthorityMunicipalityForm from "./CreatePortAuthorityMunicipalityForm";
import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog";
import SwipeableViews from 'react-swipeable-views';
import { createPortAuthority } from "../../../services/portAuthoritiesService";
import useLocale from "../../../hooks/useLocale";
import { useMutation } from "react-query";
import { useState } from "react";

const CreateDialog = ({ open, close, refetch }) => {
  const { t } = useLocale();
  const tabs = [
    t('Add new Port Authority'),
    t('Add Municipalities to Port Authority')
  ]
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState(0);

  // Mutation for creating data for port Authority
  const { mutate: portAuthMutation } = useMutation(createPortAuthority, {
    onSuccess: (data) => {
      refetch();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });


  const submitForm = (values, actions) => {
    actions.setSubmitting(true);
    handleCreateItem(values);
    actions.setSubmitting(false);
    setActiveTab(0);
  };
  const handleCreateItem = (values) => {
    const valuesToSubmit = {
      cd: values.cd,
      dscr: values.dscr,
      address: values.address,
      email: values.email,
      phone: values.phone,
      parent_id: values.parent_id ? values.parent_id : null,
      prf_list: values.prf_id
    }
    portAuthMutation({ items: JSON.stringify([valuesToSubmit]) });
  }
  const phoneRegExp = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  const validationSchema = [
    Yup.object().shape({
      cd: Yup.string().required(t("Field is required")).max(20, t("Too long")),
      dscr: Yup.string().required(t("Field is required")).max(256, t("Too long")),
      address: Yup.string().nullable().max(512, t("Too long")),
      email: Yup.string().nullable().max(256, t("Too long")),
      phone: Yup.string().nullable().matches(phoneRegExp, t('Invalid phone number')).nullable(),
    }),
    Yup.object().shape({
      prf_id: Yup
        .array()
        .of(Yup.object().shape({
          id: Yup.number().nullable()
        }).nullable()
          .strict(),
        ).nullable()
    })
  ];

  const currentValidationSchema = validationSchema[activeTab];

  const handleTabChange = () => {
    if (activeTab === 0) {
      setActiveTab(1)
    } else setActiveTab(0)
  }

  return (
    <CustomDialog open={open} maxWidth="sm" onClose={() => { close(); setError(''); setActiveTab(0) }}>
      <Tabs value={activeTab} >
        {tabs.map((label, index) => (
          <Tab key={label} label={label} onClick={handleTabChange} value={index} />
        ))}
      </Tabs>
      <>
        <CustomAlert
          open={!!error}
          close={() => { setError('') }}
          message={t('A network error occured, please try again later')}
        />
        <Formik
          initialValues={{
            cd: "",
            dscr: "",
            address: "",
            email: "",
            phone: "",
            parent_id: "",
            prf_id: null,
          }}
          validationSchema={currentValidationSchema}
          onSubmit={submitForm}
        >
          {({
            isSubmitting,
            submitForm,
            setFieldValue,
            errors,
            touched,
            values,
          }) => (
            <Form noValidate>
              <SwipeableViews index={activeTab} onChangeIndex={handleTabChange}>
                <>
                  <CreatePortAuthorityForm
                    key={0}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    values={values}
                  />
                </>
                <>
                  <CreatePortAuthorityMunicipalityForm
                    key={1}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    values={values}
                  />
                </>
              </SwipeableViews>
              <div >
                <DialogActions>
                  <Button type="submit" color="primary">
                    {t("Add")}
                  </Button>
                  <Button onClick={() => { close(); setError(''); setActiveTab(0) }} color="primary">
                    {t("Cancel")}
                  </Button>
                </DialogActions>
              </div>
            </Form>
          )}
        </Formik>
      </>
    </CustomDialog >
  );
};

export default CreateDialog;
